/* eslint-disable @typescript-eslint/no-extra-semi */
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { DropdownProps } from 'semantic-ui-react'
import classNames from 'classnames'

import { Form } from 'client/semantic-imports'
import { AppFormFieldLabel } from 'client/ui-building-blocks'

import './app-form-auto-complete.scss'

type AppFormAutoCompleteProps = {
  label: string
  placeholder: string
  value: string[] | string
  options: { value: string; text: string }[]
  disabled?: boolean
  multiple?: boolean
  search?: boolean
  error?: string
  onChange: (...event: unknown[]) => void
}

const AppFormAutoComplete = (props: AppFormAutoCompleteProps) => {
  const { t } = useTranslation()

  const {
    label,
    placeholder,
    value,
    options = [],
    disabled = false,
    multiple = false,
    search = true,
    error = '',
    onChange,
  } = props

  return (
    <div
      className={classNames(
        'appFormAutoComplete',
        error && 'error',
        options.length >= 5 && 'minHeight'
      )}
    >
      <Form.Dropdown
        label={<AppFormFieldLabel label={label} error={error} />}
        placeholder={placeholder}
        value={value}
        options={options}
        onChange={(e: ChangeEvent<HTMLInputElement>, data: DropdownProps) => {
          const value = e.target.value
          onChange({ target: { value: value !== undefined ? value : data.value } })
        }}
        search={search}
        selection
        multiple={multiple}
        disabled={disabled}
        selectOnBlur={false}
        noResultsMessage={t('common.info.nothingToDisplay')}
      />
    </div>
  )
}

export default AppFormAutoComplete
